module.exports = __webpack_public_path__ + "static/img/glyf_logo.5acecde1.jpg";